/**
 * @name 下载中心
 */
import request from '@/utils/request'

export const exportJobDelete = (user_group_id) => {
  return request({
    method: 'DELETE',
    url: `cms/export_jobs/${user_group_id}`
  })
}
